import { Component } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { Typography, Layout } from "antd";
import { SYS_CODE, SYS_VERSION } from "../../utils/contrains";

import { connect } from "react-redux";
import "./main.less";

import MainHeader from "../../components/main-header";
import MainLeftNav from "../../components/main-left-nav";

/* 基本模組 */
import Home from "../home/home";
import Category from "../business/category";
import Role from "../user/role";
import User from "../user/user";

import Business from "../business/business";
import SearchBulletinBoard from "../bulletinBoard/search-bulletinboard";
import ManageBulletinBoard from "../bulletinBoard/manage-bulletinboard";

/* 統計分析 */
import Bar from "../statistics/bar";
import Line from "../statistics/line";
import Pie from "../statistics/pie";

/* 電子報 */
import CreatorNewsContent from "../sendmailmessage/creator-news-content";
import DepartNewsContent from "../sendmailmessage/depart-news-content";
import WeekNewsContent from "../sendmailmessage/week-news-content";
/* 電腦報修 */
import ApplyCase from "../fixcomputer/apply-case";
import ReviewCase from "../fixcomputer/review-case";
import ProcessCase from "../fixcomputer/process-case";
import HistoryReviewCase from "../fixcomputer/history-review-case";

/* 服務諮詢(馬上辦) */
import Consulting from "../onestopservice/consulting";
import Questionlog from "../onestopservice/questionlog";
import KeywordList from "../onestopservice/keyword-list";

/* 應屆畢業生 */
import Preparation from "../graduatefresh/preparation";
import GraduateManage from "../graduatefresh/graduate-manage";
import GraduateClass from "../graduatefresh/graduate-class";

/* 校友服務 */
import AlumniManage from "../alumni/alumni-manage";
import AlumniGraduateHistory from "../alumni/alumni-graduate-history";
import AlumniSituationAnalysis from "../alumni/alumni-report-standard";
import EmployerManage from "../alumni/employer-manage";
import TvedbDepartment from "../alumni/tvedb-department";
import AlumniApplyUpdate from "../alumni/alumni-apply-update";
import AlumniAssignTasks from "../alumni/alumni-assign-tasks";
import AlumniOneYearNotUpdate from "../alumni/alumni-oneyear-notupdate";
import AlumniCardApply from "../alumni/alumni-card-apply";
import AlumniCardManage from "../alumni/alumni-card-manage";
import MonthStatisticsList from "../alumni/month-statistics-list";

/* 畢業生流向調查 */
import SurveyCounselorList from "../alumnisurvey/survey-counselor-list";
import SurveyAlumniList from "../alumnisurvey/survey-alumni-list";
import SurveyYearReport from "../alumnisurvey/survey-year-report";
import SurveyFirstYear from "../alumnisurvey/survey-first-year";
import SurveyThreeYear from "../alumnisurvey/survey-three-year";
import SurveyFiveYear from "../alumnisurvey/survey-five-year";
import AlumniApplyModify from "../alumnisurvey/alumni-apply-modify";
import AlumniApplyModifyList from "../alumnisurvey/alumni-apply-modify-list";
import DepartmentChiefSearchList from "../alumnisurvey/department-chief-search-list";
import GraduateSurveyInfo from "../alumnisurvey/graduate-survey-list";
import PreviousClassTeacher from "../alumnisurvey/previous-class-teacher";
import AlumniEmploymentStatus from "../alumnisurvey/alumni-employment-status";
import SurveyScheduleList from "../alumnisurvey/survey-schedule-list";
import OneYearSurveyA from "../alumnisurvey/one-year-survey-a";

/* 實名制 */
import RegisterSpaceList from "../realnamecheck/register-space";

/* 獎項預約 */
import RegisterReservation from "../awardsreservation/register-reservation";
import ClaimerOnsiteCase from "../awardsreservation/claimer-onsite-case";
import ClaimerSendmailCase from "../awardsreservation/claimer-sendmail-case";
import ClaimerNoneCase from "../awardsreservation/claimer-none-case";
import DailyQuotaAnalysis from "../awardsreservation/daily-quota-analysis";
import ApplylogReservation from "../awardsreservation/applylog-reservation";
import ConfigReservationdate from "../awardsreservation/config-reservationdate";
import ConfigQualify from "../awardsreservation/config-qualify";

/* 賃居管理 */
import SurveyStudent from "../accommodation/survey-student";
import ClassLiveList from "../accommodation/class-live-list";
import AllStudentsLiveList from "../accommodation/all-students-live-list";
import NeedConfirmTutor from "../accommodation/need-confirm-tutor";
import Needtalktutor from "../accommodation/need-talk-tutor";
import NeedConfirmInstructor from "../accommodation/need-confirm-instructor";
import OnDutySearch from "../accommodation/on-duty-search";

/* 學習點數 */
import EnglishActivity from "../learnpoints/english-activity";
import EnglishCourse from "../learnpoints/english-course";
import EnglishPointsConfig from "../learnpoints/english-points-config";
import EnglishActivityPointsRank from "../learnpoints/english-activity-points-rank";
import StudentMyselfPoints from "../learnpoints/student-myself-points";

/* 文創作品 */
import CulturalCreativeWorks from "../culturalcreativeworks/culturalcreative-works";
import ObjectCourse from "../culturalcreativeworks/object-course";
import CourseWorks from "../culturalcreativeworks/student-works-list";

/* 歷程檔案 */
import BlogConfig from "../blog/blog-config";
import BloggerInformation from "../blog/blogger-information";
import IntroductionLink from "../blog/introduction-link";
import TeacherOpenCourse from "../blog/teacher-open-course";
import StudentLearnedCourse from "../blog/student-learned-course";
import StoryJoinActivity from "../blog/story-join-activity";
import StoryHoldEvent from "../blog/story-hold-event";
import AchievementWorks from "../blog/achievement-works-list";
import AchievementDegreeLicense from "../blog/achievement-degree-license-list";
import AchievementDeedsTeacher from "../blog/achievement-deeds-teacher-list";
import AchievementDeedsStudent from "../blog/achievement-deeds-student-list";

import ManageBlggerList from "../blog/manage-blogger-list";

import VitalityIndexTeacherDissertation from "../blog/vitality-index-teacher-dissertation";
import VitalityIndexTeacherJournals from "../blog/vitality-index-teacher-journals";
import VitalityIndexTeacherBook from "../blog/vitality-index-teacher-book";
import VitalityIndexTeacherPatent from "../blog/vitality-index-teacher-patent";
import VitalityIndexTeacherProject from "../blog/vitality-index-teacher-project";
import VitalityIndexTeacherAwarded from "../blog/vitality-index-teacher-awarded";
import VitalityIndexTeacherXhibition from "../blog/vitality-index-teacher-xhibition";

import VitalityIndexStudentObjects from "../blog/vitality-index-student-objects";
import VitalityIndexStudentDeeds from "../blog/vitality-index-student-deeds";
import VitalityIndexStudentLicense from "../blog/vitality-index-student-license";
import VitalityIndexStudentActivity from "../blog/vitality-index-student-activity";

import VitalityIndexStudentComplex from "../blog/vitality-index-student-complex";
import VitalityIndexTeacherComplex from "../blog/vitality-index-teacher-complex";

import CoursemapStudentCivilservice from "../blog/coursemap-student-civilservice";
import CoursemapStudentCompletedAbility from "../blog/coursemap-student-completed-ability";
import CoursemapStudentCompletedIndex from "../blog/coursemap-student-completed-index";
import CoursemapStudentCompletedTalent from "../blog/coursemap-student-completed-talent";
import CoursemapStudentCourseLearnmap from "../blog/coursemap-student-course-learnmap";
import CoursemapStudentCourseLicensemap from "../blog/coursemap-student-course-licensemap";
import CoursemapStudentCoursePlan from "../blog/coursemap-student-course-plan";
import CoursemapStudentCourseSuggest from "../blog/coursemap-student-course-suggest";
import CoursemapStudentMatriculation from "../blog/coursemap-student-matriculation";
import CoursemapStudentOccupation from "../blog/coursemap-student-occupation";

import CoursemapStudentUcanAlsresult from "../blog/coursemap-student-ucan-alsresult";
import CoursemapStudentUcanCommoccupation from "../blog/coursemap-student-ucan-commoccupation";
import CoursemapStudentUcanDgnexplore from "../blog/coursemap-student-ucan-dgnexplore";
import CoursemapStudentUcanHolland from "../blog/coursemap-student-ucan-holland";
import UcanSsoLink from "../blog/ucan-sso-link";
import ClubStudent from "../blog/club-student-list";

/* 空間借用 */
import SpaceManagement from "../spacelend/space-management";
import SiteManagement from "../spacelend/site-management";
import DeviceManagement from "../spacelend/equipment-management";
import TimeManagement from "../spacelend/time-management";

import UserBorrowSpace from "../spacelend/user-borrow-space";
import UserBorrowLog from "../spacelend/user-borrow-log";

import ConfirmorReviewA from "../spacelend/confirmor-review-a";
import ConfirmorReviewB from "../spacelend/confirmor-review-b";
import ConfirmorReviewC from "../spacelend/confirmor-review-c";
import ConfirmorReviewHistory from "../spacelend/confirmor-review-history";

import SpaceStatusSearch from "../spacelend/space-status-search";
import CorrectLogList from "../spacelend/correct-log-list";

import MaterialStatusList from "../teachingmaterial/material-status-list";
import FinishByFulltime from "../teachingmaterial/finish-by-fulltime";
import FinishByDepartment from "../teachingmaterial/finish-by-department";

import HistoryMaterialStatusList from "../teachingmaterial/history-material-status-list";
import HistoryFinishByFulltime from "../teachingmaterial/history-finish-by-fulltime";
import HistoryFinishByDepartment from "../teachingmaterial/history-finish-by-department";

/* 空間管理 */
import SpaceManagementList from "../spacemanagement/space-management";
import SpaceManagementUnitList from "../spacemanagement/space-management-unit";
import SpaceManagementSearchList from "../spacemanagement/space-management-search";
import SpaceManagementHistoryList from "../spacemanagement/space-management-history";
import CourseWeektimesSemesterOneList from "../spacemanagement/course-weektimes-semester-one";
import CourseWeektimesSemesterThreeList from "../spacemanagement/course-weektimes-semester-three";
import SpaceBorrowList from "../spacemanagement/space-borrow";
import SpaceDepartmentList from "../spacemanagement/space-department";
import SpaceUseTypeTotal from "../spacemanagement/space-usetype-total";
import SpaceUseTypeTvbdbTotal from "../spacemanagement/space-usetypetvbdb-total";

/* 教學品保 */
import QualityManageWorkerList from "../teachingquailty/manage-worker-list";
import SecretaryManageWorkList from "../teachingquailty/secretary-work-list";

import QualityManageWorkBList from "../teachingquailty/manage-work-level-b-list";
import QualityManageWorkBReport from "../teachingquailty/manage-work-level-b-report";
import ReviewSchoolList from "../teachingquailty/review-school-list";
import SignCollegeList from "../teachingquailty/sign-college-list";

import QualityManageWorkAList from "../teachingquailty/manage-work-level-a-list";

import NormManageList from "../teachingquailty/norm-manage-list";

import SchoolQuailtyA00 from "../teachingquailty/school-quailty-a00";
// import SchoolQuailtyA01 from "../teachingquailty/school-quailty-a01";
// import SchoolQuailtyA02 from "../teachingquailty/school-quailty-a02";
// import SchoolQuailtyA03 from "../teachingquailty/school-quailty-a03";
// import SchoolQuailtyA04 from "../teachingquailty/school-quailty-a04";
// import SchoolQuailtyA05 from "../teachingquailty/school-quailty-a05";

import QualityManageWorkCList from "../teachingquailty/manage-work-level-c-list";
import QualityManageWorkCReport from "../teachingquailty/manage-work-level-c-report";
import QualityManageWorkDList from "../teachingquailty/manage-work-level-d-list";
import QualityManageWorkDReport from "../teachingquailty/manage-work-level-d-report";

import ReviewDepartmentList from "../teachingquailty/review-department-list";
import SignDepartmentList from "../teachingquailty/sign-department-list";
import QuailtyManualLink from "../teachingquailty/quailty-manual-link";
import GraduateSurveyList from "../teachingquailty/graduate-survey-list";

import AllManualIndex from "../teachingquailty/all-manual-index";
import FreshWorkPercentage from "../graduatefresh/fresh-work-percentage";
/* 主管查詢 */
import AlumniModifyStatistics from "../decisionsupport/alumni-modify-statistics-list";
import AlumniEmploymentStatistics from "../decisionsupport/alumni-employmentrate-statistics-list";
/* 徵稿票選 */
import MyParticipantRegisterList from "../contestsignup/my-participant-register-list";
import JuryAllWorksList from "../contestsignup/jury-all-works-list";
import ManagerChoiceWorksList from "../contestsignup/manager-choice-works-list";
import VoterChoiceWorksList from "../contestsignup/voter-choice-works-list";
import ManagerSetFinishScoreList from "../contestsignup/manager-set-finish-score-list";
import ManagerLotteryList from "../contestsignup/manager-lottery-list";

import SchoolRollSearch from "../alumni/school-roll-search";
/* 校門管制 */
import GateControlConfig from "../gatesecurity/gate-control-config";
import GateControlLogList from "../gatesecurity/gate-control-log-list";
import SignerEnrolmentView from "../gatesecurity/signer-enrolment-view";
import SignerEnrolmentSelf from "../gatesecurity/signer-enrolment-self";
import LastEnrolmentView from "../gatesecurity/last-enrolment-view";
import SignerEnrolmentList from "../gatesecurity/signer-enrolment-list";
import SignerEnrolmentHistoryList from "../gatesecurity/signer-enrolment-history-list";
import DepartmentAnalyzeList from "../gatesecurity/department-analyze-list";
/* 資訊素養 */
import ILAStudentList from "../inforliteracy/ila-student-list";
import ILACourseList from "../inforliteracy/ila-course-list";
/* 生源規劃 */
import StudentSourceEditList from "../studentsourceplan/student-source-edit-list";
import StudentDepartmentSeniorEditList from "../studentsourceplan/student-department-senior-edit-list";
import StudentDepartmentJuniorEditList from "../studentsourceplan/student-department-junior-edit-list";
import StudentDepartmentViewList from "../studentsourceplan/student-department-view-list";
import SchoolPlanTargetGoal from "../studentsourceplan/school-plan-target-goal";
import CollegePlanViewList from "../studentsourceplan/college-plan-view-list";
import DepartmentPlanViewList from "../studentsourceplan/department-plan-view-list";
import StudentSourceJuniorEditList from "../studentsourceplan/student-source-junior-edit-list";
import SourcePlanManageWorkerList from "../studentsourceplan/manage-worker-list";
import SchoolPlanStisticsList from "../studentsourceplan/school-plan-statistics-list";
import CollegePlanStisticsList from "../studentsourceplan/college-plan-statistics-list";
import DepartmentPlanStatisticsList from "../studentsourceplan/department-plan-statistics-list";
import StudentDepartmentSeniorManageList from "../studentsourceplan/student-department-senior-manage-list";
import StudentsNowInfoAll from "../studentsourceplan/students-now-info-all";
import DepartmentZoneList from "../studentsourceplan/department-zone-list";
import IRSourceSchoolAnalysis from "../studentsourceplan/ir-source-school-analysis";
import IRSourceEntranceAnalysis from "../studentsourceplan/ir-source-entrance-analysis";

import StudentApplyScholarships from "../alumnischolarships/student-apply-scholarships";
import StudentApplyLog from "../alumnischolarships/student-apply-log";
import ApplyCaseManagement from "../alumnischolarships/apply-case-management";
import ApplyCaseLog from "../alumnischolarships/apply-case-log";

import SchoolPlanMonthHistory from "../studentsourceplan/school-plan-month-history";
import SchoolPlanTargetHoldon from "../studentsourceplan/school-plan-target-holdon";
import CollegeHandleStatisticesList from "../studentsourceplan/college-handle-statistices-list";
import ChairHandleStatisticesList from "../studentsourceplan/chair-handle-statistices-list";
import DeanChairGooutLogList from "../studentsourceplan/dean-chair-goout-log-list";
import PrincipalAllInOneList from "../studentsourceplan/principal-all-in-one-list";
import DeanTargetPages from "../studentsourceplan/dean-target-pages";
import StatusTimeSetup from "../alumnischolarships/status-time-setup";

import AiPromptStandard from "../aiprompt/ai-prompt-standard";
import CreateExamQuestion from "../aiprompt/create-exam-question";
import CreateCounseling from "../aiprompt/create-counseling";
import CreateCourseSelection from "../aiprompt/create-course-selection";
import CreateCourseOutline from "../aiprompt/create-course-outline";
import AiCourseResponse from "../aiprompt/ai-course-response";

import SchoolPlanTargetGoalNight from "../studentsourceplan/school-plan-target-goal-night";
import NightStudentDepartmentViewList from "../studentsourceplan/night-student-department-view-list";
import NightStudentManageList from "../studentsourceplan/night-student-manage-list";
// 考勤打卡
import OneDaySelf from "../punchinout/one-day-self";
import ClockLogSelf from "../punchinout/clock-log-self";
import OverTimeLogSelf from "../punchinout/over-time-log-self";
import OverTimeLogStaff from "../punchinout/over-time-log-staff";
import Flexiblelogself from "../punchinout/flexible-log-self";
import SwapLogSelf from "../punchinout/swap-log-self";
import AllApplyCasesReview from "../punchinout/all-apply-cases-review";
import StandardTimeStaff from "../punchinout/standard-time-staff";
import FlexibleLogGroup from "../punchinout/flexible-log-group";
import FlexiblelogStaff from "../punchinout/flexible-log-staff";
import ClockLogStaff from "../punchinout/clock-log-staff";
import OvertimeMonthNowStaff from "../punchinout/overtime-month-now-staff";
import StaffBunchWarning from "../punchinout/staff-bunch-warning";
import BackfillLogStaff from "../punchinout/backfill-log-staff";
import BunchLogStaff from "../punchinout/bunch-log-staff";
import StaffLeaveStatistics from "../punchinout/staff-leave-statistics";
import StaffLeaveApplyLog from "../punchinout/staff-leave-apply-log";
import StaffLeaveLogSearch from "../punchinout/staff-leave-log-search";
//AI
import AiNotebooklmSearch from "../aiprompt/ai-notebooklm-search";
import ClassC000111 from "../aiprompt/class-c0001-11";
import ClassC000112 from "../aiprompt/class-c0001-12";
import ClassC000113 from "../aiprompt/class-c0001-13";
import ClassC000114 from "../aiprompt/class-c0001-14";
import ClassC000121 from "../aiprompt/class-c0001-21";
import ClassC000122 from "../aiprompt/class-c0001-22";
import ClassC000123 from "../aiprompt/class-c0001-23";
import ClassC000124 from "../aiprompt/class-c0001-24";
import ClassC000131 from "../aiprompt/class-c0001-31";
import ClassC000132 from "../aiprompt/class-c0001-32";

//遠距教學
import RemoteLearningCourse from "../distancelearning/remote-learning-course";
import CourseStudentEveryweekLog from "../distancelearning/course-student-everyweek-log";

//NotebookLM公開筆記查詢平台
import AllNotebooklmList from "../ainotebooklm/all-notebooklm-list";
import MyNotebooklmList from "../ainotebooklm/my-notebooklm-list";
import ChosenNotebooklmList from "../ainotebooklm/chosen-notebooklm-list";

/////////////////

import NotFound from "../not-found/not-found";
import { SYS_COPYRIGHT, SYS_INFO, SYS_NAME } from "../../utils/contrains";

const { Text } = Typography;
const { Footer, Sider, Content } = Layout;
/*
後台管理的路由組件
*/
class Main extends Component {
  componentDidMount() {
    document.title = SYS_NAME;
  }

  versionInfo = () => {
    var showVer = false;
    switch (SYS_CODE) {
      case "GQM":
      case "EPS":
      case "DSS":
      case "CSLL":
      case "CSLC":
      case "TMS":
      case "ECA":
      case "AMS":
      case "SSP":
      case "APC":
      case "PIM":
        showVer = false;
        break;
      default:
        showVer = true;
    }
    return showVer ? (
      <Footer
        className="webVisible"
        style={{ textAlign: "center", padding: "10px 0 !important" }}
      >
        {SYS_COPYRIGHT} 版號：{SYS_VERSION}
        <br></br>
        <Text style={{ color: "white" }}>{SYS_INFO}</Text>
      </Footer>
    ) : (
      ""
    );
  };

  menuToggle = () => {
    const elMenu = document.getElementById("left-menu");
    elMenu.classList.toggle("hiddenleftmenuctl");
    const eltopMenu = document.getElementById("top-menu");
    eltopMenu.classList.toggle("showtopmenu");
  };

  ///////////////////////////////////////////
  render() {
    const user = this.props.user;
    if (!user || !user.token) {
      return <Redirect to="/login" />;
    } else {
      return (
        <Layout style={{ height: "100%" }} className="main">
          <input
            type="checkbox"
            name=""
            id="sideMenu-active"
            onClick={this.menuToggle}
          />
          <Sider
            className="webVisible"
            style={{ backgroundColor: "#301356" }}
            id="left-menu"
          >
            <label htmlFor="sideMenu-active" id="sideMenu-label">
              <i className="fas fa-angle-right"></i>
            </label>
            <MainLeftNav />
          </Sider>
          <Layout id="content-area">
            <MainHeader />
            <Content
              style={{
                margin: "5px",
                backgroundColor: "#fff",
                overflow: "auto",
              }}
            >
              <Switch>
                <Redirect exact from="/" to="/home" />
                <Route path="/home" component={Home} />

                <Route path="/work/category" component={Category} />
                <Route path="/work/business" component={Business} />

                <Route path="/member/role" component={Role} />
                <Route path="/member/user" component={User} />

                <Route path="/punchinout/onedayself" component={OneDaySelf} />
                <Route
                  path="/punchinout/bunchLogStaff"
                  component={BunchLogStaff}
                />

                <Route
                  path="/punchinout/clocklogself"
                  component={ClockLogSelf}
                />
                <Route
                  path="/punchinout/overtimelogself"
                  component={OverTimeLogSelf}
                />
                <Route
                  path="/punchinout/overtimelogstaff"
                  component={OverTimeLogStaff}
                />
                <Route path="/punchinout/swaplogself" component={SwapLogSelf} />

                <Route
                  path="/punchinout/flexiblelogself"
                  component={Flexiblelogself}
                />

                <Route
                  path="/punchinout/allapplycasesreview"
                  component={AllApplyCasesReview}
                />
                <Route
                  path="/punchinout/standardtimestaff"
                  component={StandardTimeStaff}
                />
                <Route
                  path="/punchinout/flexiblelogstaff"
                  component={FlexiblelogStaff}
                />
                <Route
                  path="/punchinout/flexibleloggroup"
                  component={FlexibleLogGroup}
                />
                <Route
                  path="/punchinout/clocklogstaff"
                  component={ClockLogStaff}
                />
                <Route
                  path="/punchinout/overtimemonthnowstaff"
                  component={OvertimeMonthNowStaff}
                />
                <Route
                  path="/punchinout/staffbunchwarning"
                  component={StaffBunchWarning}
                />

                <Route
                  path="/punchinout/backfilllogstaff"
                  component={BackfillLogStaff}
                />

                <Route
                  path="/punchinout/staffleavestatistics"
                  component={StaffLeaveStatistics}
                />
                <Route
                  path="/punchinout/staffleaveapplylog"
                  component={StaffLeaveApplyLog}
                />
                <Route
                  path="/punchinout/staffleavelogsearch"
                  component={StaffLeaveLogSearch}
                />



                <Route
                  path="/sendmailmessage/creatornewscontent"
                  component={CreatorNewsContent}
                />
                <Route
                  path="/aiprompt/aipromptstandard"
                  component={AiPromptStandard}
                />
                <Route
                  path="/aiprompt/counseling"
                  component={CreateCounseling}
                />
                <Route
                  path="/aiprompt/courseselection"
                  component={CreateCourseSelection}
                />
                <Route
                  path="/aiprompt/aicoursereponse"
                  component={AiCourseResponse}
                />
                <Route
                  path="/aiprompt/ainotebooklmsearch"
                  component={AiNotebooklmSearch}
                />

                <Route
                  path="/aiprompt/courseoutline"
                  component={CreateCourseOutline}
                />
                <Route
                  path="/aiprompt/examquestion"
                  component={CreateExamQuestion}
                />

                <Route
                  path="/aiprompt/class_C0001_11"
                  component={ClassC000111}
                />
                <Route
                  path="/aiprompt/class_C0001_12"
                  component={ClassC000112}
                />
                <Route
                  path="/aiprompt/class_C0001_13"
                  component={ClassC000113}
                />
                <Route
                  path="/aiprompt/class_C0001_14"
                  component={ClassC000114}
                />
                <Route
                  path="/aiprompt/class_C0001_21"
                  component={ClassC000121}
                />
                <Route
                  path="/aiprompt/class_C0001_22"
                  component={ClassC000122}
                />
                <Route
                  path="/aiprompt/class_C0001_23"
                  component={ClassC000123}
                />
                <Route
                  path="/aiprompt/class_C0001_24"
                  component={ClassC000124}
                />
                <Route
                  path="/aiprompt/class_C0001_31"
                  component={ClassC000131}
                />
                <Route
                  path="/aiprompt/class_C0001_32"
                  component={ClassC000132}
                />

                <Route
                  path="/sendmailmessage/departnewscontent"
                  component={DepartNewsContent}
                />
                <Route
                  path="/sendmailmessage/weeknewscontent"
                  component={WeekNewsContent}
                />

                <Route
                  path="/bulletin/searchbulletinboard"
                  component={SearchBulletinBoard}
                />
                <Route
                  path="/bulletin/managebulletinboard"
                  component={ManageBulletinBoard}
                />

                <Route path="/statistics/bar" component={Bar} />
                <Route path="/statistics/line" component={Line} />
                <Route path="/statistics/pie" component={Pie} />

                <Route path="/fixcomputer/applycase" component={ApplyCase} />
                <Route path="/fixcomputer/reviewcase" component={ReviewCase} />
                <Route
                  path="/fixcomputer/processcase"
                  component={ProcessCase}
                />
                <Route
                  path="/fixcomputer/historyreviewcase"
                  component={HistoryReviewCase}
                />

                <Route
                  path="/studentsource/manageworker"
                  component={SourcePlanManageWorkerList}
                />

                <Route
                  path="/studentsource/collegeplanview"
                  component={CollegePlanViewList}
                />

                <Route
                  path="/studentsource/departmentplanview"
                  component={DepartmentPlanViewList}
                />
                <Route
                  path="/studentsource/chairhandlestatistics"
                  component={ChairHandleStatisticesList}
                />
                <Route
                  path="/studentsource/deanchairgooutlog"
                  component={DeanChairGooutLogList}
                />

                <Route
                  path="/studentsource/sourceplan"
                  component={StudentSourceEditList}
                />

                <Route
                  path="/studentsource/departmentplanningrate"
                  component={SchoolPlanTargetGoal}
                />

                <Route
                  path="/studentsource/departmentplanningratenight"
                  component={SchoolPlanTargetGoalNight}
                />

                <Route
                  path="/studentsource/departmenttargetholdon"
                  component={SchoolPlanTargetHoldon}
                />

                <Route
                  path="/studentsource/collegehandlestatistices"
                  component={CollegeHandleStatisticesList}
                />

                <Route
                  path="/studentsource/principalallInonelist"
                  component={PrincipalAllInOneList}
                />

                <Route
                  path="/studentsource/departmentseniorplan"
                  component={StudentDepartmentSeniorEditList}
                />
                <Route
                  path="/studentsource/departmentjuniorplan"
                  component={StudentDepartmentJuniorEditList}
                />

                <Route
                  path="/studentsource/departmentprincipal"
                  component={StudentDepartmentViewList}
                />

                <Route
                  path="/studentsource/departmentprincipalnight"
                  component={NightStudentDepartmentViewList}
                />

                <Route
                  path="/studentsource/sourceplannight"
                  component={NightStudentManageList}
                />

                <Route
                  path="/studentsource/sourceseniorplan"
                  component={StudentDepartmentSeniorManageList}
                />

                <Route
                  path="/studentsource/sourcejuniorplan"
                  component={StudentSourceJuniorEditList}
                />

                <Route
                  path="/studentsource/schoolplanstatistics"
                  component={SchoolPlanStisticsList}
                />
                <Route
                  path="/studentsource/collegeplanstatistics"
                  component={CollegePlanStisticsList}
                />
                <Route
                  path="/studentsource/departmentplanstatistics"
                  component={DepartmentPlanStatisticsList}
                />
                <Route
                  path="/studentsource/studentsnowinfoall"
                  component={StudentsNowInfoAll}
                />
                <Route
                  path="/studentsource/schoolplanmonthhistory"
                  component={SchoolPlanMonthHistory}
                />
                <Route
                  path="/studentsource/deanTarget"
                  component={DeanTargetPages}
                />
                <Route
                  path="/studentsource/departmentzone"
                  component={DepartmentZoneList}
                />
                <Route
                  path="/studentsource/irsourceschoolanalysis"
                  component={IRSourceSchoolAnalysis}
                />
                <Route
                  path="/studentsource/irsourceentranceanalysis"
                  component={IRSourceEntranceAnalysis}
                />

                <Route
                  path="/onestopservice/consulting"
                  component={Consulting}
                />
                <Route
                  path="/onestopservice/keywordList"
                  component={KeywordList}
                />
                <Route
                  path="/onestopservice/questionlog"
                  component={Questionlog}
                />

                <Route
                  path="/graduatefresh/preparation"
                  component={Preparation}
                />
                <Route
                  path="/graduatefresh/graduatemanage"
                  component={GraduateManage}
                />
                <Route
                  path="/graduatefresh/graduateclass"
                  component={GraduateClass}
                />
                <Route
                  path="/graduatefresh/freshworkpercentage"
                  component={FreshWorkPercentage}
                />
                <Route
                  path="/alumni/alumniinformation"
                  component={AlumniManage}
                />
                <Route
                  path="/alumni/alumnigraduate"
                  component={AlumniGraduateHistory}
                />
                <Route
                  path="/alumni/tablereportstandard"
                  component={AlumniSituationAnalysis}
                />
                <Route
                  path="/alumni/alumniemployer"
                  component={EmployerManage}
                />
                <Route
                  path="/alumni/tvedbdepartment"
                  component={TvedbDepartment}
                />
                <Route
                  path="/alumni/alumniapplyUpdate"
                  component={AlumniApplyUpdate}
                />
                <Route path="/alumni/cardapply" component={AlumniCardApply} />
                <Route path="/alumni/cardmanage" component={AlumniCardManage} />
                <Route
                  path="/alumni/assigntasks"
                  component={AlumniAssignTasks}
                />

                <Route
                  path="/alumni/oneyearnotupdate"
                  component={AlumniOneYearNotUpdate}
                />

                <Route
                  path="/alumni/monthstatisticslist"
                  component={MonthStatisticsList}
                />

                <Route
                  path="/alumnisurvey/jobsearchstatistics"
                  component={AlumniEmploymentStatus}
                />
                <Route
                  path="/alumnisurvey/surveycounselorlist"
                  component={SurveyCounselorList}
                />
                <Route
                  path="/alumnisurvey/surveyschedule"
                  component={SurveyScheduleList}
                />
                <Route
                  path="/alumnisurvey/surveyalumnilist"
                  component={SurveyAlumniList}
                />
                <Route
                  path="/alumnisurvey/surveyearreport"
                  component={SurveyYearReport}
                />
                <Route
                  path="/alumnisurvey/alumniapplymodify"
                  component={AlumniApplyModify}
                />
                <Route
                  path="/alumnisurvey/surveyfirstyear"
                  component={SurveyFirstYear}
                />
                <Route
                  path="/alumnisurvey/surveythreeyear"
                  component={SurveyThreeYear}
                />
                <Route
                  path="/alumnisurvey/surveyfiveyear"
                  component={SurveyFiveYear}
                />
                <Route
                  path="/alumnisurvey/alumniapplymodifylist"
                  component={AlumniApplyModifyList}
                />
                <Route
                  path="/alumnisurvey/chiefsearchlist"
                  component={DepartmentChiefSearchList}
                />
                <Route
                  path="/alumnisurvey/graduatesurveylist"
                  component={GraduateSurveyInfo}
                />
                <Route
                  path="/alumnisurvey/employmentratelist"
                  component={AlumniEmploymentStatistics}
                />
                <Route
                  path="/alumnisurvey/previousclassteacher"
                  component={PreviousClassTeacher}
                />
                <Route
                  path="/alumnisurvey/oneyearsurveya"
                  component={OneYearSurveyA}
                />

                <Route
                  path="/realnamecheck/registerspacelist"
                  component={RegisterSpaceList}
                />

                <Route
                  path="/awardsreservation/registerreservation"
                  component={RegisterReservation}
                />
                <Route
                  path="/awardsreservation/onsiteclaimerlist"
                  component={ClaimerOnsiteCase}
                />
                <Route
                  path="/awardsreservation/sendmailclaimerlist"
                  component={ClaimerSendmailCase}
                />
                <Route
                  path="/awardsreservation/noneclaimerlist"
                  component={ClaimerNoneCase}
                />
                <Route
                  path="/awardsreservation/dailyquotaanalysis"
                  component={DailyQuotaAnalysis}
                />
                <Route
                  path="/awardsreservation/searchrecord"
                  component={ApplylogReservation}
                />
                <Route
                  path="/awardsreservation/configqualify"
                  component={ConfigQualify}
                />
                <Route
                  path="/awardsreservation/configreservationdate"
                  component={ConfigReservationdate}
                />

                <Route
                  path="/accommodation/surveystudent"
                  component={SurveyStudent}
                />
                <Route
                  path="/accommodation/classlivelist"
                  component={ClassLiveList}
                />
                <Route
                  path="/accommodation/allstudentslivelist"
                  component={AllStudentsLiveList}
                />
                <Route
                  path="/accommodation/needconfirmtutor"
                  component={NeedConfirmTutor}
                />
                <Route
                  path="/accommodation/needtalktutor"
                  component={Needtalktutor}
                />
                <Route
                  path="/accommodation/needConfirminstructor"
                  component={NeedConfirmInstructor}
                />
                <Route
                  path="/accommodation/onDutySearch"
                  component={OnDutySearch}
                />

                <Route
                  path="/learnpoints/activity"
                  component={EnglishActivity}
                />
                <Route path="/learnpoints/course" component={EnglishCourse} />
                <Route
                  path="/learnpoints/config"
                  component={EnglishPointsConfig}
                />
                <Route
                  path="/learnpoints/points"
                  component={EnglishActivityPointsRank}
                />
                <Route
                  path="/learnpoints/selfpoints"
                  component={StudentMyselfPoints}
                />

                <Route
                  path="/culturalcreativeworks/works"
                  component={CulturalCreativeWorks}
                />
                <Route
                  path="/culturalcreativeworks/course"
                  component={ObjectCourse}
                />
                <Route
                  path="/culturalcreativeworks/courseworks"
                  component={CourseWorks}
                />

                <Route path="/eportfolio/config" component={BlogConfig} />
                <Route
                  path="/eportfolio/baseinfo"
                  component={BloggerInformation}
                />
                <Route
                  path="/eportfolio/introductionlink"
                  component={IntroductionLink}
                />
                <Route
                  path="/eportfolio/opencourse"
                  component={TeacherOpenCourse}
                />
                <Route
                  path="/eportfolio/learnedcourse"
                  component={StudentLearnedCourse}
                />
                <Route
                  path="/eportfolio/joinactivity"
                  component={StoryJoinActivity}
                />
                <Route
                  path="/eportfolio/holdevent"
                  component={StoryHoldEvent}
                />
                <Route
                  path="/eportfolio/achievementworks"
                  component={AchievementWorks}
                />

                <Route
                  path="/eportfolio/degreelicense"
                  component={AchievementDegreeLicense}
                />
                <Route
                  path="/eportfolio/deedsteacher"
                  component={AchievementDeedsTeacher}
                />
                <Route
                  path="/eportfolio/deedsstudent"
                  component={AchievementDeedsStudent}
                />

                <Route
                  path="/eportfolio/managebloggers"
                  component={ManageBlggerList}
                />

                <Route
                  path="/eportfolio/vitalitydissertation"
                  component={VitalityIndexTeacherDissertation}
                />
                <Route
                  path="/eportfolio/vitalityjournals"
                  component={VitalityIndexTeacherJournals}
                />
                <Route
                  path="/eportfolio/vitalitybook"
                  component={VitalityIndexTeacherBook}
                />
                <Route
                  path="/eportfolio/vitalitypatent"
                  component={VitalityIndexTeacherPatent}
                />
                <Route
                  path="/eportfolio/vitalityproject"
                  component={VitalityIndexTeacherProject}
                />
                <Route
                  path="/eportfolio/vitalityawarded"
                  component={VitalityIndexTeacherAwarded}
                />
                <Route
                  path="/eportfolio/vitalityxhibition"
                  component={VitalityIndexTeacherXhibition}
                />

                <Route
                  path="/eportfolio/vitalityobjects"
                  component={VitalityIndexStudentObjects}
                />
                <Route
                  path="/eportfolio/vitalitydeeds"
                  component={VitalityIndexStudentDeeds}
                />
                <Route
                  path="/eportfolio/vitalitylicense"
                  component={VitalityIndexStudentLicense}
                />
                <Route
                  path="/eportfolio/vitalityactivity"
                  component={VitalityIndexStudentActivity}
                />

                <Route
                  path="/eportfolio/complexvtalitystudent"
                  component={VitalityIndexStudentComplex}
                />
                <Route
                  path="/eportfolio/complexVitalityteacher"
                  component={VitalityIndexTeacherComplex}
                />

                <Route
                  path="/eportfolio/coursemapstudentcivilservice"
                  component={CoursemapStudentCivilservice}
                />
                <Route
                  path="/eportfolio/coursemapstudentoccupation"
                  component={CoursemapStudentOccupation}
                />
                <Route
                  path="/eportfolio/coursemapstudentmatriculation"
                  component={CoursemapStudentMatriculation}
                />

                <Route
                  path="/eportfolio/coursemapstudentcompletedtalent"
                  component={CoursemapStudentCompletedTalent}
                />
                <Route
                  path="/eportfolio/coursemapstudentcompletedability"
                  component={CoursemapStudentCompletedAbility}
                />
                <Route
                  path="/eportfolio/coursemapstudentcompletedindex"
                  component={CoursemapStudentCompletedIndex}
                />
                <Route
                  path="/eportfolio/coursemapstudentcourseplan"
                  component={CoursemapStudentCoursePlan}
                />
                <Route
                  path="/eportfolio/coursemapstudentcoursesuggest"
                  component={CoursemapStudentCourseSuggest}
                />
                <Route
                  path="/eportfolio/coursemapstudentcourselearnmap"
                  component={CoursemapStudentCourseLearnmap}
                />
                <Route
                  path="/eportfolio/coursemapstudentcourselicensemap"
                  component={CoursemapStudentCourseLicensemap}
                />

                <Route path="/eportfolio/ucanssolink" component={UcanSsoLink} />
                <Route
                  path="/eportfolio/coursemapstudentucanholland"
                  component={CoursemapStudentUcanHolland}
                />
                <Route
                  path="/eportfolio/coursemapstudentucandgnexplore"
                  component={CoursemapStudentUcanDgnexplore}
                />
                <Route
                  path="/eportfolio/coursemapstudentucancommoccupation"
                  component={CoursemapStudentUcanCommoccupation}
                />
                <Route
                  path="/eportfolio/coursemapstudentucanalsresult"
                  component={CoursemapStudentUcanAlsresult}
                />
                <Route path="/eportfolio/clubstudent" component={ClubStudent} />

                <Route
                  path="/spacelend/spacemanagement"
                  component={SpaceManagement}
                />
                <Route
                  path="/spacelend/timemanagement"
                  component={TimeManagement}
                />
                <Route
                  path="/spacelend/sitemanagement"
                  component={SiteManagement}
                />
                <Route
                  path="/spacelend/devicemanagement"
                  component={DeviceManagement}
                />

                <Route
                  path="/spacelend/userborrowspace"
                  component={UserBorrowSpace}
                />
                <Route
                  path="/spacelend/userborrowlog"
                  component={UserBorrowLog}
                />

                <Route
                  path="/spacelend/confirmorreviewa"
                  component={ConfirmorReviewA}
                />
                <Route
                  path="/spacelend/confirmorreviewb"
                  component={ConfirmorReviewB}
                />
                <Route
                  path="/spacelend/confirmorreviewc"
                  component={ConfirmorReviewC}
                />
                <Route
                  path="/spacelend/confirmorreviewhistory"
                  component={ConfirmorReviewHistory}
                />

                <Route
                  path="/spacelend/spacestatussearch"
                  component={SpaceStatusSearch}
                />
                <Route
                  path="/spacelend/correctlog"
                  component={CorrectLogList}
                />

                <Route
                  path="/teachingMaterial/materialstatuslist"
                  component={MaterialStatusList}
                />
                <Route
                  path="/teachingMaterial/finishbyfulltime"
                  component={FinishByFulltime}
                />
                <Route
                  path="/teachingMaterial/finishbydepartment"
                  component={FinishByDepartment}
                />

                <Route
                  path="/teachingMaterial/historymaterialstatuslist"
                  component={HistoryMaterialStatusList}
                />
                <Route
                  path="/teachingMaterial/historyfinishbyfulltime"
                  component={HistoryFinishByFulltime}
                />
                <Route
                  path="/teachingMaterial/historyfinishbydepartment"
                  component={HistoryFinishByDepartment}
                />
                <Route
                  path="/decisionsupport/alumnimodifystatisticslist"
                  component={AlumniModifyStatistics}
                />
                <Route
                  path="/contestsignup/myparticipantregisterlist"
                  component={MyParticipantRegisterList}
                />
                <Route
                  path="/contestsignup/juryallworkslist"
                  component={JuryAllWorksList}
                />
                <Route
                  path="/contestsignup/managerchoiceworkslist"
                  component={ManagerChoiceWorksList}
                />
                <Route
                  path="/contestsignup/voterchoiceworkslist"
                  component={VoterChoiceWorksList}
                />
                <Route
                  path="/contestsignup/managersetfinishscorelist"
                  component={ManagerSetFinishScoreList}
                />
                <Route
                  path="/contestsignup/managerlotterylist"
                  component={ManagerLotteryList}
                />

                <Route
                  path="/spacemanagement/base"
                  component={SpaceManagementList}
                />
                <Route
                  path="/spacemanagement/history"
                  component={SpaceManagementHistoryList}
                />
                <Route
                  path="/spacemanagement/unit"
                  component={SpaceManagementUnitList}
                />
                <Route
                  path="/spacemanagement/search"
                  component={SpaceManagementSearchList}
                />
                <Route
                  path="/spacemanagement/onesemesterweektimes"
                  component={CourseWeektimesSemesterOneList}
                />
                <Route
                  path="/spacemanagement/threesemesterweektimes"
                  component={CourseWeektimesSemesterThreeList}
                />
                <Route
                  path="/spacemanagement/borrowtotaltimes"
                  component={SpaceBorrowList}
                />
                <Route
                  path="/spacemanagement/spacedepartment"
                  component={SpaceDepartmentList}
                />

                <Route
                  path="/spacemanagement/usetypetotal"
                  component={SpaceUseTypeTotal}
                />

                <Route
                  path="/spacemanagement/tvbtypetotal"
                  component={SpaceUseTypeTvbdbTotal}
                />

                <Route
                  path="/teachingquailty/normmanage"
                  component={NormManageList}
                />

                <Route
                  path="/teachingquailty/workerlist"
                  component={QualityManageWorkerList}
                />

                <Route
                  path="/teachingquailty/A00"
                  component={SchoolQuailtyA00}
                />

                {/* <Route
                  path="/teachingquailty/A01"
                  component={SchoolQuailtyA01}
                />
                <Route
                  path="/teachingquailty/A02"
                  component={SchoolQuailtyA02}
                />
                <Route
                  path="/teachingquailty/A03"
                  component={SchoolQuailtyA03}
                />
                <Route
                  path="/teachingquailty/A04"
                  component={SchoolQuailtyA04}
                />
                <Route
                  path="/teachingquailty/A05"
                  component={SchoolQuailtyA05}
                /> */}

                <Route
                  path="/teachingquailty/workalist"
                  component={QualityManageWorkAList}
                />
                <Route
                  path="/teachingquailty/workblist"
                  component={QualityManageWorkBList}
                />
                <Route
                  path="/teachingquailty/workbreport"
                  component={QualityManageWorkBReport}
                />

                <Route
                  path="/teachingquailty/workclist"
                  component={QualityManageWorkCList}
                />
                <Route
                  path="/teachingquailty/workcreport"
                  component={QualityManageWorkCReport}
                />

                <Route
                  path="/teachingquailty/workdlist"
                  component={QualityManageWorkDList}
                />
                <Route
                  path="/teachingquailty/workdreport"
                  component={QualityManageWorkDReport}
                />

                <Route
                  path="/teachingquailty/secretaryassign"
                  component={SecretaryManageWorkList}
                />

                <Route
                  path="/teachingquailty/bossa"
                  component={SignCollegeList}
                />
                <Route
                  path="/teachingquailty/bossb"
                  component={SignCollegeList}
                />
                <Route
                  path="/teachingquailty/bosscd"
                  component={SignDepartmentList}
                />

                <Route
                  path="/teachingquailty/syslink"
                  component={QuailtyManualLink}
                />

                <Route
                  path="/teachingquailty/reviewschool"
                  component={ReviewSchoolList}
                />
                <Route
                  path="/teachingquailty/reviewdepartment"
                  component={ReviewDepartmentList}
                />

                <Route
                  path="/teachingquailty/graduatesurvey"
                  component={GraduateSurveyList}
                />

                <Route
                  path="/teachingquailty/allmanualindex"
                  component={AllManualIndex}
                />

                <Route
                  path="/school/schoolrollsearch"
                  component={SchoolRollSearch}
                />

                <Route
                  path="/gatesecurity/gatecontrolconfig"
                  component={GateControlConfig}
                />
                <Route
                  path="/gatesecurity/gatecontrolloglist"
                  component={GateControlLogList}
                />
                <Route
                  path="/gatesecurity/signerenrolmenthistorylist"
                  component={SignerEnrolmentHistoryList}
                />

                <Route
                  path="/gatesecurity/departmentanalyzelist"
                  component={DepartmentAnalyzeList}
                />

                <Route
                  path="/gatesecurity/signerenrolmentview"
                  component={SignerEnrolmentView}
                />

                <Route
                  path="/gatesecurity/signerenrolmentself"
                  component={SignerEnrolmentSelf}
                />

                <Route
                  path="/gatesecurity/lastenrolmentview"
                  component={LastEnrolmentView}
                />

                <Route
                  path="/gatesecurity/signerenrolmentlist"
                  component={SignerEnrolmentList}
                />

                <Route
                  path="/inforliteracy/ilacourselist"
                  component={ILACourseList}
                />
                <Route
                  path="/inforliteracy/ilastudentlist"
                  component={ILAStudentList}
                />

                <Route
                  path="/alumnischolarships/applyscholarship"
                  component={StudentApplyScholarships}
                />
                <Route
                  path="/alumnischolarships/studentapplylog"
                  component={StudentApplyLog}
                />
                <Route
                  path="/alumnischolarships/applycasemanagement"
                  component={ApplyCaseManagement}
                />
                <Route
                  path="/alumnischolarships/applycaselog"
                  component={ApplyCaseLog}
                />
                <Route
                  path="/alumnischolarships/statustimesetup"
                  component={StatusTimeSetup}
                />
                <Route
                  path="/distancelearning/allcourse"
                  component={RemoteLearningCourse}
                />
                <Route
                  path="/distancelearning/studenthourscheck"
                  component={CourseStudentEveryweekLog}
                />

                <Route
                  path="/ainotebooklm/allnotebooklm"
                  component={AllNotebooklmList}
                />
                <Route
                  path="/ainotebooklm/mynotebooklm"
                  component={MyNotebooklmList}
                />
                <Route
                  path="/ainotebooklm/chosennotebooklm"
                  component={ChosenNotebooklmList}
                />

                <Route component={NotFound} />
              </Switch>
            </Content>
            {this.versionInfo()}
          </Layout>
        </Layout>
      );
    }
  }
}

export default connect((state) => ({ user: state.user }), {})(Main);
